// extracted by mini-css-extract-plugin
module.exports = {"body":"BodyCopy_body__i-VD7 fs-bodyCopy multilang-support"};